import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/tabs';
import CustomersPanel from './CustomersPanel';
import CampaignsPanel from './CampaignsPanel';
import OrdersPanel from './OrdersPanel';
import LeadsPanel from './LeadsPanel';
import SocialPanel from './SocialPanel';
import { Zap, LogOut } from 'lucide-react';

export default function AdminDashboard() {
  const { admin, logout } = useAuth();
  const [tab, setTab] = useState('customers');

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="admin-dashboard">
      <header className="border-b border-white/10 sticky top-0 bg-[#050505]/90 backdrop-blur z-10">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Zap className="text-red-500" size={22} fill="currentColor" />
            <span className="text-white font-black text-lg tracking-tight">S-MAN <span className="text-red-500">ADMIN</span></span>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-white/40 text-sm hidden sm:inline">{admin?.email}</span>
            <button
              data-testid="logout-button"
              onClick={logout}
              className="text-white/60 hover:text-red-400 flex items-center gap-1.5 text-sm"
            >
              <LogOut size={16} /> Esci
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 py-8">
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList className="bg-[#0d0d0d] border border-white/10 mb-6">
            <TabsTrigger value="customers" data-testid="tab-customers">Clienti</TabsTrigger>
            <TabsTrigger value="campaigns" data-testid="tab-campaigns">Campagne Email</TabsTrigger>
            <TabsTrigger value="orders" data-testid="tab-orders">Ordini</TabsTrigger>
            <TabsTrigger value="leads" data-testid="tab-leads">B2B Leads</TabsTrigger>
            <TabsTrigger value="social" data-testid="tab-social">Social</TabsTrigger>
          </TabsList>
          <TabsContent value="customers"><CustomersPanel /></TabsContent>
          <TabsContent value="campaigns"><CampaignsPanel /></TabsContent>
          <TabsContent value="orders"><OrdersPanel /></TabsContent>
          <TabsContent value="leads"><LeadsPanel /></TabsContent>
          <TabsContent value="social"><SocialPanel /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
